:host {
  display: inline-block;
}

.cc-logo {
  border-radius: var(--sc-cc-border-radius, 4px);
  line-height: 0;
  overflow:hidden;
}
